export default __webpack_public_path__ + "static/media/L_wdt_c_cap_0.77cbfb3e.mp3";